import { useScript } from "@bokio/hooks/useScript/useScript";

export const VerveTracking = () => {
	useScript("https://static2.creative-serving.com/pixel_loader.js");

	return null;
};
